export class AuctionPaymentRequest{

    public id!:number;
    public auctionId!:number;
    public scheduleSeqNo!:number;
    public userId!:string;
    public amount!:number;
    public paymentProvider?:string;
    public gatewayReference?:string;
    public gatewayResponse?:string;
    public gatewayStatus?:string;
    public created?:Date;
    public updated?:Date;
    public success:boolean = false;

    constructor(){
    }
}